import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import getSingleParamFromJs from "../../Utils/getSingleParamFromJs";
import formatValue from "../../../../Utils/ListUtils/FormatValue";

const defaultRefreshTime = 1000 * 60;

async function getDateTimeSource(source) {
    try {
        const customSource = await getSingleParamFromJs(source, {}, '', '');
        if (new Date(customSource) instanceof Date) {
            return customSource
        }
        console.log('Error, source is not date-time instance, source is: ' + customSource)
        return null;
    } catch (e) {
        throw e;
    }
}

function getSystemDateTimeFormat() {
    try {
        const userStorage = JSON.parse(sessionStorage.getItem('user'));
        if(userStorage) {
            return userStorage.system ? userStorage.system.dateTimeFormat : null
        }
        return null;
    } catch (e) {
        console.log(e);
        return null;
    }
}

const ServerTime = props => {
    const {component: {properties: {source, refreshTime, format} = {}, styles: sourceStyles} = {}} = props;
    const styles = sourceStyles ? sourceStyles[0] : {};
    const [currentTime, setCurrentTime] = useState(null);
    const [sessionFormat, setSessionFormat] = useState(null);

    useEffect(() => {
        initServerTime();
        const timerId = setInterval(refreshClock, 1000);
        const syncTimerId = setInterval(syncTimeWithSource, refreshTime ? refreshTime * 1000 * 60 : defaultRefreshTime);
        const dateTimeFormat = getSystemDateTimeFormat();
        setSessionFormat(dateTimeFormat)
        return () => {
            clearInterval(timerId)
            clearInterval(syncTimerId)
        }
    }, [])

    async function initServerTime() {
        try {
            const customSource = await getDateTimeSource(source);
            if (customSource) {
                refreshClock(customSource)
            }
        } catch (e) {
            console.log('init server time error', e)
        }
    }

    async function syncTimeWithSource() {
        try {
            const customSource = await getDateTimeSource(source)
            if (customSource) {
                setCurrentTime(new Date(customSource))
            }
        } catch (e) {
            console.log('Sync time error', e)
        }
    }

    function refreshClock(initDateTime) {
        setCurrentTime(state => {
            return initDateTime ?
                new Date(initDateTime) :
                new Date(new Date(state).setSeconds(new Date(state).getSeconds() + 1))
        });
    }

    return (
        <div
            style={{
                ...styles
            }}
            className={'sb-server-time ' +  styles.className}
        >
            {currentTime ? formatValue(currentTime, 'datetime', format ? format : sessionFormat) : '...'}
        </div>
    );
};

ServerTime.propTypes = {
    component: PropTypes.shape({
        properties: PropTypes.shape({
            source: PropTypes.string,
            refreshTime: PropTypes.number,
            format: PropTypes.string
        })
    })
};

export default ServerTime;